import * as angular from 'angular';
import 'angular-ui-router';
import { applicationListStateName } from 'modules/application/list';
import { MicroFrontendService } from 'modules/shared/MicroFrontendService';
import { CDPController } from './CDPController';
import { CDPFeatures } from './CDPFeatures';
import CDPView from './CDPView.html';
import { cdpScriptSource } from 'app.constants';
export const cdpStateName = 'auth.cdp';
export const anyPathsStateName = 'auth.cdp.any';
export const cdpHome = 'auth.cdp.home';
export const cdpImportState = 'auth.cdp.import';
export default angular
    .module('cdp', [
    'ui.router',
])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state(cdpStateName, {
            template: CDPView,
            controller: CDPController,
            controllerAs: '$ctrl',
            resolve: {
                authorization: fetchTenantCrmPermission,
            },
            onEnter: () => {
                return MicroFrontendService.addSource(cdpScriptSource);
            },
        }).state(cdpHome, {
            url: '/audiences',
            views: {
                '@auth.cdp': {
                    template: CDPView,
                    controller: CDPController,
                    controllerAs: '$ctrl',
                },
            },
            resolve: {
                authorization: fetchTenantCrmPermission,
            },
        }).state(anyPathsStateName, {
            url: '/audiences/{path:any}',
            views: {
                '@auth.cdp': {
                    template: CDPView,
                    controller: CDPController,
                    controllerAs: '$ctrl',
                },
            },
            resolve: {
                authorization: fetchTenantCrmPermission,
            },
        });
    }]).name;
const fetchTenantCrmPermission = ['$state', 'InitializeUserService', 'ContextProcessorService', async function ($state, InitializeUserService, ContextProcessorService) {
        await ContextProcessorService.waitForInitialization();
        const tenantId = ContextProcessorService.tenant.id;
        await InitializeUserService.initFeatureToggle();
        const isTenantAllowedToAccessBeta = await CDPFeatures.isTenantIdOnBeta(tenantId);
        if (!isTenantAllowedToAccessBeta) {
            $state.go(applicationListStateName);
        }
    }];
